import { gql } from '@apollo/client'

export const JOIN_WAIT_LIST_MUTATION = gql`
  mutation($input: JoinWaitingListInput!) {
    joinWaitingList(input: $input) {
      id
      
      group {
        id
      }
      
      lesson {
        id
      }
      
      student {
        id
      }

      guardian {
        id
      }
      
      comment
    }
  }
`

export const LEAVE_WAIT_LIST_MUTATION = gql`
  mutation($input: LeaveWaitingListInput!) {
    leaveWaitingList(input: $input)
  }
`